// import React from 'react';
// import { Box, Container, Typography, Grid, Divider } from '@mui/material';

// export default function Footer() {
//   return (
//     <Box component="footer" sx={{ py: 8, bgcolor: 'rgba(30, 91, 92, 1)' }}>
//       <Container maxWidth="lg">
//         <Grid container spacing={3} sx={{ mb: 6 }}>
//           <Grid item xs={12} md={3}>
//             <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
//               SHREE CONSULTANCY
//             </Typography>
//             <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
//               Your trusted Consultant for all your business needs like GST, Income Tax, Business
//               Registration and Loan Services.
//             </Typography>
//           </Grid>
          
//           <Grid item xs={12} md={3}>
//             <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, mb: 2 ,pl:'66px'}}>
//               Quick Links
//             </Typography>
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1,pl:'67px' }}>
//               <Typography
//                 variant="body2"
//                 onClick={() => {
//                   document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
//                   window.history.pushState({}, '', '/services');
//                 }}
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   cursor: 'pointer',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 Services
//               </Typography>
//               <Typography
//                 variant="body2"
//                 onClick={() => {
//                   document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
//                   window.history.pushState({}, '', '/about');
//                 }}
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   cursor: 'pointer',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 About Us
//               </Typography>
//               <Typography
//                 variant="body2"
//                 onClick={() => {
//                   document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' });
//                   window.history.pushState({}, '', '/testimonials');
//                 }}
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   cursor: 'pointer',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 Testimonials
//               </Typography>
//               <Typography
//                 variant="body2"
//                 onClick={() => {
//                   document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
//                   window.history.pushState({}, '', '/faq');
//                 }}
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   cursor: 'pointer',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 FAQ
//               </Typography>
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
//               Contact
//             </Typography>
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//               <Typography
//                 component="a"
//                 href="tel:+918758485159"
//                 variant="body2"
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   textDecoration: 'none',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 +91 87584 85159
//               </Typography>
//               <Typography
//                 component="a"
//                 href="mailto:nikhilamareliya@gmail.com"
//                 variant="body2"
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   textDecoration: 'none',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 nikhilamareliya@gmail.com
//               </Typography>
//             </Box>
//           </Grid>
//         </Grid>
        
//         <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', mb: 4 }} />
        
//         <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', textAlign: 'center' }}>
//           © {new Date().getFullYear()} SHREE CONSULTANCY.
//          </Typography>
//       </Container>
//     </Box>
//   );
// }
// ===========================
// import React from 'react';
// import { Box, Container, Typography, Grid, Divider } from '@mui/material';

// export default function Footer() {
//   return (
//     <Box component="footer" sx={{ py: 8, bgcolor: 'rgba(30, 91, 92, 1)' }}>
//       <Container maxWidth="lg">

       
//         <Grid 
//           container 
//           spacing={4} 
//           sx={{ mb: 6, alignItems: 'flex-start' }}
//         >
//           <Grid item xs={12} md={3}>
//             <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
//               SHREE CONSULTANCY
//             </Typography>
//             <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
//               Your trusted Consultant for all your business needs like GST, Income Tax,
//               Business Registration and Loan Services.
//             </Typography>
//           </Grid>

//           <Grid item xs={12} md={3} sx={{ml:'200px'}}>
//             <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
//               Quick Links
//             </Typography>

//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//               <Typography
//                 variant="body2"
//                 onClick={() => {
//                   document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
//                   window.history.pushState({}, '', '/services');
//                 }}
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   cursor: 'pointer',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 Services
//               </Typography>

//               <Typography
//                 variant="body2"
//                 onClick={() => {
//                   document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
//                   window.history.pushState({}, '', '/about');
//                 }}
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   cursor: 'pointer',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 About Us
//               </Typography>

//               <Typography
//                 variant="body2"
//                 onClick={() => {
//                   document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' });
//                   window.history.pushState({}, '', '/testimonials');
//                 }}
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   cursor: 'pointer',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 Testimonials
//               </Typography>

//               <Typography
//                 variant="body2"
//                 onClick={() => {
//                   document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
//                   window.history.pushState({}, '', '/faq');
//                 }}
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   cursor: 'pointer',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 FAQ
//               </Typography>
//             </Box>
//           </Grid>

//           {/* Column 3 */}
//           <Grid item xs={12} md={3} sx={{ml:'250px'}}>
//             <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
//               Contact
//             </Typography>

//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//               <Typography
//                 component="a"
//                 href="tel:+918758485159"
//                 variant="body2"
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   textDecoration: 'none',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
                  
//                 }}
//               >
//                 +91 87584 85159
//               </Typography>

//               <Typography
//                 component="a"
//                 href="mailto:nikhilamareliya@gmail.com"
//                 variant="body2"
//                 sx={{
//                   color: 'rgba(255,255,255,0.8)',
//                   textDecoration: 'none',
//                   '&:hover': { color: 'white' },
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 nikhilamareliya@gmail.com
//               </Typography>
//             </Box>
//           </Grid>
//         </Grid>

//         <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', mb: 4 }} />

//         <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', textAlign: 'center' }}>
//           © {new Date().getFullYear()} SHREE CONSULTANCY.
//         </Typography>

//       </Container>
//     </Box>
//   );
// }

import React from 'react';
import { Box, Container, Typography, Grid, Divider } from '@mui/material';

export default function Footer() {
  return (
    <Box component="footer" sx={{ py: 8, bgcolor: 'rgba(30, 91, 92, 1)' }}>
      <Container maxWidth="lg">

        {/* 3 Columns - Perfectly aligned */}
        <Grid 
          container 
          spacing={4} 
          justifyContent="space-between" 
          alignItems="flex-start"
          sx={{ mb: 6 }}
        >

          {/* Column 1 */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
              SHREE CONSULTANCY
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
              Your trusted Consultant for all your business needs like GST, Income Tax,
              Business Registration and Loan Services.
            </Typography>
          </Grid>

          {/* Column 2 */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
              Quick Links
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography
                variant="body2"
                onClick={() => {
                  document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/services');
                }}
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  cursor: 'pointer',
                  '&:hover': { color: 'white' },
                }}
              >
                Services
              </Typography>

              <Typography
                variant="body2"
                onClick={() => {
                  document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/about');
                }}
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  cursor: 'pointer',
                  '&:hover': { color: 'white' },
                }}
              >
                About Us
              </Typography>

              <Typography
                variant="body2"
                onClick={() => {
                  document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/testimonials');
                }}
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  cursor: 'pointer',
                  '&:hover': { color: 'white' },
                }}
              >
                Testimonials
              </Typography>

              <Typography
                variant="body2"
                onClick={() => {
                  document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/faq');
                }}
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  cursor: 'pointer',
                  '&:hover': { color: 'white' },
                }}
              >
                FAQ
              </Typography>
            </Box>
          </Grid>

          {/* Column 3 */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
              Contact
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography
                component="a"
                href="tel:+918758485159"
                variant="body2"
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  textDecoration: 'none',
                  '&:hover': { color: 'white' },
                }}
              >
                +91 87584 85159
              </Typography>

              <Typography
                component="a"
                href="mailto:nikhilamareliya@gmail.com"
                variant="body2"
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  textDecoration: 'none',
                  '&:hover': { color: 'white' },
                }}
              >
                nikhilamareliya@gmail.com
              </Typography>
            </Box>
          </Grid>

        </Grid>

        {/* Divider */}
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', mb: 4 }} />

        {/* Footer bottom */}
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', textAlign: 'center' }}>
          © {new Date().getFullYear()} SHREE CONSULTANCY.
        </Typography>

      </Container>
    </Box>
  );
}
